module.exports = __webpack_public_path__ + "static/media/wu-bg-alternate-logo-gray2.1e273784.svg";